import React, { useState, useContext, useRef, useEffect } from 'react';
import { Button, Row, Col, Tooltip } from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { Formik, Form, Field } from 'formik';
import { DateTime } from "luxon";
import { gql, useQuery, useMutation } from '@apollo/client';
import { useIntl } from 'react-intl';
import Swal from 'sweetalert2';

import { ReactDatePicker, ReactSwitch, TimePicker, Input } from '../helpers/formik';
import getEncodedImageUrl from '../helpers/get-encoded-image';
import { BackArrow } from './svgs'
import { PreLoader } from './preloader';
import { Presentation } from '../types/presentation';
import { useHistory } from "react-router-dom";
import EventContext from '../contexts/event';
import axios, { AxiosResponse } from "axios";
import toast, { Toaster } from 'react-hot-toast';

import { secondsToTime } from '../helpers';

const presentation_by_pk = gql`
  query presentation_by_pk($id: String!) {
    presentation_by_pk(id: $id) {
      id
      live
      questions_from_time
      questions_to_time
      results_from_time
      results_to_time
      timer
    }
  }
`

const update_presentation_by_pk = gql`
  mutation update_presentation_by_pk(
    $pk_columns: presentation_pk_columns_input!
    $live: Boolean
    $questions_from_time: timestamptz
    $questions_to_time: timestamptz
    $results_from_time: timestamptz
    $results_to_time: timestamptz
    $timer:Int
  ) {
    update_presentation_by_pk(
      pk_columns: $pk_columns,
      _set: {
        live: $live
        questions_from_time: $questions_from_time
        questions_to_time: $questions_to_time
        results_from_time: $results_from_time
        results_to_time: $results_to_time
        timer:$timer
      }
    ) {
      id
      questions_from_time
      questions_to_time
      results_from_time
      results_to_time
      live
      timer
    }
  }
`

const SidebarQuizModerator: React.FC<{
  addQuestionFromSideBar?: (arg0: any) => any;
  presentation: Presentation;
  saveActioncall?: (arg0: any) => void;

}> = ({ addQuestionFromSideBar, presentation, saveActioncall }) => {
  const eventContext = useContext(EventContext);
  const [mobEdit, setMobEdit] = useState(false);
  const location = useLocation();
  const [isVirtual] = useState(queryString.parse(location.search).viewmode === "virtual");
  const intl = useIntl();
  const saveRef = useRef<any>();
  const toggleEdit = () => {
    setMobEdit(!mobEdit)
  }

  let history = useHistory();

  const { data, loading: queryLoading } = useQuery(presentation_by_pk, {
    variables: {
      id: presentation && presentation._id
    },
    skip: !presentation
  })


  const notify = () => {

    toast.success("Copied to clipboard", { position: 'top-left' })
  };


  useEffect(() => {
     console.log("Action Cliced useEffect");
    if (saveRef.current) {
      saveRef.current.handleSubmit();
       console.log("Action Cliced useEffect Inside", saveRef.current);
    }

  }, [saveActioncall]);

  const [update_presentation_by_pk_mutation, { loading: mutationLoading }] = useMutation(update_presentation_by_pk, {
    onCompleted: (response) => {

       console.log("TIMER", response);
       console.log("TIMER onCompleted");

      // try {
      //   axios({
      //     method: "POST",
      //     //url: 'http://localhost:4000/stage/api/quiz/update-code',
      //     url: `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/update-code`,
      //     data: {
      //       _id: presentation._id
      //     },
      //   })
      // } catch (e) {
      //    console.log("TIMER", e);
      // }

    },
    onError: (error) => {
       console.log("update_presentation_by_pk_mutation", error);
       console.log("TIMER", error);
      // Swal.fire({
      //   title: 'There was an error',
      //   icon: 'error',
      // })
    }
  })


  if (queryLoading || !presentation) {
    return <PreLoader />
  }

  if (!data || !data.presentation_by_pk) {
    return <i>Error while fetching presentation data</i>
  }

  const _questions_from_time = DateTime.fromISO(data.presentation_by_pk.questions_from_time).toISO();
  const _questions_to_time = DateTime.fromISO(data.presentation_by_pk.questions_to_time).toISO();
  const _results_from_time = DateTime.fromISO(data.presentation_by_pk.results_from_time).toISO();
  const _results_to_time = DateTime.fromISO(data.presentation_by_pk.results_to_time).toISO();
   console.log("TIMER 1", data.presentation_by_pk.timer);


  return (
    <>
      <div className="sidebar ">
        <div className="sidebar-main quiz-user quiz-moderator moderator-curve">
          <div className="logo-container">
            {/* <img src="/images/logoplaceholder.png" alt="logo" /> */}
            <span className="day">
              {!isVirtual && <span className="day-text">{intl.formatMessage({ id: 'day' })} {presentation.day}</span>}
              <span className="useless-line"></span>
              {!isVirtual && presentation.date && <span className="date">{DateTime.fromFormat(presentation.date, 'yyyy-MM-dd').toFormat('D')}</span>}
            </span>
            <h6>{presentation.name}</h6>
            <div className="speaker-deails-sidebar">
              {
                presentation.speaker_info && presentation.speaker_info.picture ? <img src={getEncodedImageUrl(presentation.speaker_info && presentation.speaker_info.picture, 56, 56)} alt="speaker" /> : <img src="/images/plimgspeaker.png" alt="speaker" />
              }
              <div>
                <p>{presentation.speaker_info && presentation.speaker_info.title} {presentation.speaker_info && presentation.speaker_info.firstName} {presentation.speaker_info && presentation.speaker_info.lastName}</p>
                {
                  !isVirtual &&
                  presentation.time &&
                  presentation.end_time &&
                  <span className="time-room-container">
                    {secondsToTime(presentation.time)} - {secondsToTime(presentation.end_time)}
                    <span className="room-name">{presentation.room_info && presentation.room_info.name}</span>
                  </span>
                }
              </div>
            </div>
            <div className="back-link m-t-30">
              <Button onClick={() => history.push(`/${eventContext.slug}${document.location.search}`)} color="link"><BackArrow />{intl.formatMessage({ id: 'button.common.back' })}</Button>
            </div>
          </div>
          <div className={`nav-conatiner ${mobEdit ? 'show-mob-edit' : ''} mobile-unset-padding`}>
            <>
              <Button onClick={() => toggleEdit()} className="btn-edit btn-curve  m-t-30" color="secondary" type="button">Edit<img src="/icons/down-arrow-white-chev.svg" alt="" /></Button>

              <Formik
                initialValues={{
                  questions_from_date: _questions_from_time || '',
                  questions_from_time: _questions_from_time ? _questions_from_time.substr(11, 5) : '10:00',
                  questions_to_date: _questions_to_time || '',
                  questions_to_time: _questions_to_time ? _questions_to_time.substr(11, 5) : '12:00',
                  results_from_date: _results_from_time || '',
                  results_from_time: _results_from_time ? _results_from_time.substr(11, 5) : '12:00',
                  results_to_date: _results_to_time || '',
                  results_to_time: _results_to_time ? _results_to_time.substr(11, 5) : '14:00',
                  live: !!data.presentation_by_pk.live,
                  timer: data.presentation_by_pk.timer || 30
                }}
                innerRef={saveRef}
                onSubmit={async (values) => {

                   console.log("TIMER S", values.timer);

                  // if mode is live then only change the value //
                  // if(values.live === false) {
                  // false mode
                  // check dates validity
                  const questions_from_time = DateTime.fromISO(values.questions_from_date)
                    .set({
                      hour: DateTime.fromISO(values.questions_from_time).hour,
                      minute: DateTime.fromISO(values.questions_from_time).minute
                    });

                  const questions_to_time = DateTime.fromISO(values.questions_to_date)
                    .set({
                      hour: DateTime.fromISO(values.questions_to_time).hour,
                      minute: DateTime.fromISO(values.questions_to_time).minute
                    });

                  const results_from_time = DateTime.fromISO(values.results_from_date)
                    .set({
                      hour: DateTime.fromISO(values.results_from_time).hour,
                      minute: DateTime.fromISO(values.results_from_time).minute
                    });

                  const results_to_time = DateTime.fromISO(values.results_to_date)
                    .set({
                      hour: DateTime.fromISO(values.results_to_time).hour,
                      minute: DateTime.fromISO(values.results_to_time).minute
                    });

                  if (questions_to_time <= questions_from_time) {
                    Swal.fire({
                      title: 'Questions To time, should be greater than Questions From time',
                      icon: 'warning',
                    })
                    return;
                  }

                  // if(results_from_time < questions_to_time) {
                  //   // TODO
                  //   Swal.fire({
                  //     title: 'Results From time, should be greater than or equal to Questions To time',
                  //     icon: 'warning',
                  //   })
                  //   return;
                  // }

                  if (results_to_time <= results_from_time) {
                    // TODO
                    Swal.fire({
                      title: 'Results To time, should be greater than Results From time',
                      icon: 'warning',
                    })
                    return;
                  }




                   console.log("TIMER->>>>>>>>>>>>>>", "update_presentation_by_pk_mutation",{
                    pk_columns: {
                      id: presentation._id
                    },
                    questions_from_time: questions_from_time.toISO(),
                    questions_to_time: questions_to_time.toISO(),
                    results_from_time: results_from_time.toISO(),
                    results_to_time: results_to_time.toISO(),
                    live: values.live,
                    timer: values.timer
                  });

                  await update_presentation_by_pk_mutation({
                    variables: {
                      pk_columns: {
                        id: presentation._id
                      },
                      questions_from_time: questions_from_time.toISO(),
                      questions_to_time: questions_to_time.toISO(),
                      results_from_time: results_from_time.toISO(),
                      results_to_time: results_to_time.toISO(),
                      live: values.live,
                      timer: values.timer
                    }
                  })
                  //}
                }}
              >
                {({ values }) => {

                  return (
                    <Form className="sidebar-form mobile_background">
                      {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
                      <Row>
                        <Col xs={9}>
                          {
                            !values.live &&
                            <p>{intl.formatMessage({ id: 'quiz.show.questions' })}</p>
                          }
                        </Col>
                        <Col className="text-center" xs={3}>
                          <span className="live-text">LIVE</span>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={9}>
                          {
                            !values.live &&
                            <React.Fragment>
                              <Row>
                                <Col xs={3}>
                                    <span className="label-text from">{intl.formatMessage({id:'quiz.from'})}</span>
                                </Col>
                                <Col>
                                  <div className="date-time-picker-container">
                                    <Field
                                      name="questions_from_date"
                                      component={ReactDatePicker}
                                      placeholder='00/00/00'
                                      required
                                      clasName="form-control"
                                    />
                                    <Field
                                      component={TimePicker}
                                      name="questions_from_time"
                                      id="questions_from_time"
                                      label={"0h00"}
                                      placeholder="0h00"
                                      changeText={"Done"}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={3}>
                                    <span className="label-text from">{intl.formatMessage({id:'quiz.to'})}</span>
                                </Col>
                                <Col>
                                  <div className="date-time-picker-container">
                                    <Field
                                      name="questions_to_date"
                                      component={ReactDatePicker}
                                      placeholder='00/00/00'
                                      required
                                      // disabled={!values.questions_from_date}
                                      clasName="form-control"
                                    />
                                    <Field
                                      component={TimePicker}
                                      name="questions_to_time"
                                      id="questions_to_time"
                                      label={"0h00"}
                                      placeholder="0h00"
                                      changeText={"Done"}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <p className="m-t-20 m-b-20">{intl.formatMessage({ id: 'quiz.show.results' })}</p>
                              <Row>
                                <Col xs={3}>
                                  <span className="label-text from">{intl.formatMessage({id:'quiz.from'})}</span>
                                </Col>
                                <Col>
                                  <div className="date-time-picker-container">
                                    <Field
                                      name="results_from_date"
                                      component={ReactDatePicker}
                                      placeholder='00/00/00'
                                      // required
                                      clasName="form-control"
                                    />
                                    <Field
                                      component={TimePicker}
                                      name="results_from_time"
                                      id="results_from_time"
                                      label={"0h00"}
                                      placeholder="0h00"
                                      changeText={"Done"}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xs={3}>
                                    <span className="label-text from">{intl.formatMessage({id:'quiz.to'})}</span>
                                </Col>
                                <Col>
                                  <div className="date-time-picker-container">
                                    <Field
                                      name="results_to_date"
                                      component={ReactDatePicker}
                                      placeholder='00/00/00'
                                      // required
                                      clasName="form-control"
                                    />
                                    <Field
                                      component={TimePicker}
                                      name="results_to_time"
                                      id="results_to_time"
                                      label={"0h00"}
                                      placeholder="0h00"
                                      changeText={"Done"}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </React.Fragment>
                          }
                          {values.live &&
                            <div className="d-none d-lg-block">
                              <Row>
                                <Col>
                                  <div className={`quiz-timer ${values.live ? 'live-space' : ''}`}>
                                    <p className="m-t-20 m-b-10">Quiz timer</p>
                                    <Field
                                      type="number"
                                      name="timer"
                                      required
                                      component={Input}
                                      placeholder="00s"
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <a className="link-btn m-t-30" href={`/${eventContext.slug}/${presentation._id}/quiz-user-list`}>SPEAKER MODE<img src="/icons/arrow-right-link.svg" alt="" /></a>
                              <div style={{ cursor: 'pointer' }} onClick={() => {
                                notify()
                                navigator.clipboard.writeText(window.location.origin + `/${eventContext.slug}/${presentation._id}/quiz-user-list`)
                              }}> <span className="url-text"><img src="/icons/link-ico.svg" alt="" />Url for Speaker mode</span></div>


                              <Link className="link-btn m-t-30" target="_blank" to={`/${eventContext.slug}/${presentation._id}/quiz-user-list`} >SCREEN MODE<img src="/icons/arrow-right-link.svg" alt="" /></Link>
                              <div style={{ cursor: 'pointer' }} onClick={() => {
                                notify()
                                navigator.clipboard.writeText(window.location.origin + `/${eventContext.slug}/${presentation._id}/screen-user-list`)
                              }}> <span className="url-text"><img src="/icons/link-ico.svg" alt="" />Url for Screen Mode</span></div>
                              <Toaster />
                            </div>}

                        </Col>
                        <Col xs={3}>
                          <div className="m-t-30">
                            <Field
                              component={ReactSwitch}
                              name="live"
                              id="live"
                              disabled={false}
                            />
                          </div>
                        </Col>
                      </Row>

                      <div className="d-block d-lg-none">
                        <a className="link-btn m-t-30" href={`/${eventContext.slug}/quiz-user-list`}>SPEAKER MODE<img src="/icons/arrow-right-link.svg" alt="" /></a>
                        <div style={{ cursor: 'pointer' }} onClick={() => {
                          navigator.clipboard.writeText(window.location.origin)
                        }}> <span className="url-text"><img src="/icons/link-ico.svg" alt="" />Url for Speaker mode</span></div>
                        <Link className="link-btn m-t-30" to="/">SCREEN MODE<img src="/icons/arrow-right-link.svg" alt="" /></Link>
                        <span className="url-text"><img src="/icons/link-ico.svg" alt="" />Url for Screen Mode</span>
                      </div>

                      <Button className="btn-submit m-t-30 btn-hide" color="primary" type="submit" disabled={mutationLoading}>{intl.formatMessage({ id: 'save' })}</Button>
                      <Button onClick={(e) => addQuestionFromSideBar && addQuestionFromSideBar(e)} className="btn-submit m-t-30" color="primary" type="button"><img src="/icons/add-ico.svg" alt="" />{intl.formatMessage({ id: 'quiz.add.question' })}</Button>
                    </Form>
                  )
                }}
              </Formik>
            </>
          </div>
        </div>
      </div>
    </>
  )
}

export default SidebarQuizModerator;
